import { LOGIN_TITLE, LOGIN_SUBTITLE } from '@/config/brandConfig'

/**
 * Login Screen Configuration
 * Easy to customize - change colors, text, or button styles!
 *
 * WIREFRAME DESIGN - Feel free to modify to match your brand
 * All visual elements are configurable here for easy future changes
 */

/**
 * Color Scheme - Tailwind classes
 * Change these to match your desired theme
 */
export const loginColors = {
  // Background - light pink (#FFE4E8)
  background: 'bg-pink-100',

  // Container box - white
  containerBackground: 'bg-white',
  containerShadow: 'shadow-lg',
  containerRounded: 'rounded-lg',

  // Join button - pink (big button)
  joinButtonBackground: 'bg-pink-200',
  joinButtonHover: 'hover:bg-pink-300',
  joinButtonText: 'text-black',

  // Login button - pink (below join)
  loginButtonBackground: 'bg-pink-300',
  loginButtonHover: 'hover:bg-pink-400',
  loginButtonText: 'text-black',

  // Submit button (email form) - pink
  submitButtonBackground: 'bg-pink-500',
  submitButtonHover: 'hover:bg-pink-600',
  submitButtonText: 'text-white',

  // Header text
  titleText: 'text-black',
  subtitleText: 'text-black',

  // Footer/Terms text
  termsText: 'text-gray-500',

  // Input fields
  inputBorder: 'border-gray-300',
  inputFocus: 'focus:ring-pink-500 focus:border-pink-500',

  // Error text
  errorText: 'text-red-600',

  // Back button
  backButtonText: 'text-gray-600',
  backButtonHover: 'hover:text-gray-800'
}

/**
 * UI Text
 * All text used in the login screen
 */
export const loginText = {
  // Header
  title: LOGIN_TITLE,
  subtitle: LOGIN_SUBTITLE,

  // Buttons (initial state)
  loginButton: 'enter',

  // Coming soon message for join
  comingSoonMessage: 'Coming Soon: Request to join will be available soon!',

  // Email form (after clicking login)
  emailLabel: 'Email address',
  emailPlaceholder: 'you@example.com',
  submitButton: 'Send login code',
  submitButtonLoading: 'Sending code...',
  backButton: '← Back',

  // Terms
  termsText: 'by logging in you agree to the terms of service and privacy policy',

  // Validation
  emailValidationError: 'Please enter a valid email address'
}

/**
 * Layout Configuration
 * Defines spacing, sizing, and arrangement
 */
export const loginLayout = {
  // Container sizing
  maxWidth: 'max-w-md',
  padding: 'px-4',

  // Spacing
  headerMarginBottom: 'mb-6',
  containerPadding: 'p-8', // Increased from p-6 to make box taller
  buttonSpacing: 'space-y-4',
  formSpacing: 'space-y-4',

  // Button sizing
  buttonPadding: 'py-3',
  buttonRounded: 'rounded-lg',
  buttonFontSize: 'text-sm',

  // Animations
  enableAnimations: true,
  animationDuration: 'animate-slide-up',
  animationDelay: 'animate-delay-100',
  fadeInAnimation: 'animate-fade-in'
}

/**
 * Feature Flags
 * Enable/disable features easily
 */
export const loginFeatures = {
  // Show terms of service text
  showTerms: true,

  // Show animations
  enableAnimations: true,

  // Enable button hover effects
  enableHoverEffects: true,

  // Show subtitle
  showSubtitle: true,

  // Join button behavior
  joinButtonBehavior: 'alert' as 'alert' | 'navigate' // 'alert' or 'navigate' to /join route
}

/**
 * Button Configuration
 */
export const loginButtons = {
  login: {
    label: loginText.loginButton,
    type: 'button' as const,
    fontWeight: 'font-bold'
  },
  submit: {
    label: loginText.submitButton,
    loadingLabel: loginText.submitButtonLoading,
    type: 'submit' as const,
    fontWeight: 'font-bold'
  }
}
